import type { RouteLocationNormalizedGeneric, NavigationGuardReturn } from 'vue-router'
import { createAuthenticatedGuard, createNotAuthenticatedGuard } from './authenticated.ts'
import { createHasRoleGuard } from './hasRole.ts'
import { Routes } from '../../Constants/Routes.ts'
import type { Guard } from './types'
import type { Role } from '../../Constants/Role.ts'

export class RouterGuardCollection {
  #guards: Guard[] = [];

  [Symbol.iterator](): ArrayIterator<Guard> {
    return this.#guards[Symbol.iterator]()
  }

  add(guard: Guard): this {
    this.#guards.push(guard)

    return this
  }

  notAuthenticated(): this {
    this.add(createNotAuthenticatedGuard())

    return this
  }

  authenticated(): this {
    this.add(createAuthenticatedGuard())

    return this
  }

  hasRole(...roles: Role[]): this {
    this.add(createHasRoleGuard(...roles))

    return this
  }
}

export function assertThat(): RouterGuardCollection {
  return new RouterGuardCollection()
}

export function guard(to: RouteLocationNormalizedGeneric): NavigationGuardReturn {
  const guards: RouterGuardCollection | null = to.meta.guards ?? null
  if (guards === null) {
    return true
  }

  for (const handler of guards) {
    const navigationGuardReturn = handler()

    if (true === navigationGuardReturn) {
      continue
    } else if (false === navigationGuardReturn) {
      return { name: Routes.HOME }
    }

    return navigationGuardReturn
  }

  return true
}
